import { useCustomFieldsForRole } from '@/hooks/useCustomFieldsForRole';
import { Field, Select } from '@payaca/ambrosia';

import { CustomFieldTaskValues } from '@/ui/components/createEditTaskSidebar/types';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export type { CustomFieldTaskValues };

const CustomFieldTaskFieldset: FC<{
  isEditing: boolean;
}> = (props) => {
  const { isEditing } = props;

  const { fieldGroup: projectFieldGroup, customFields: projectCustomFields } =
    useCustomFieldsForRole('project', ['fieldset']);

  const { control, register } = useFormContext<CustomFieldTaskValues>();

  return (
    <>
      <Controller
        render={({ field: { value, onChange, name } }) => {
          return (
            <Field name={name}>
              <Field.Label>Custom fieldset</Field.Label>

              <Select
                disabled={isEditing}
                multiple={false}
                value={value}
                onChange={onChange}
                options={projectCustomFields.map((customField) => ({
                  label: customField.label,
                  value: customField.identifier,
                }))}
              />
            </Field>
          );
        }}
        name="customFieldIdentifier"
        control={control}
        shouldUnregister
      />

      {projectFieldGroup && (
        <input
          type="hidden"
          {...register('customFieldGroupId', {
            shouldUnregister: true,
            value: projectFieldGroup?.id,
          })}
        />
      )}
    </>
  );
};

export default CustomFieldTaskFieldset;
